export const GET_NOTIFICATION_REPORT_DATA =
  'notificationReport/GET_NOTIFICATION_REPORT_DATA';
export const GET_NOTIFICATION_REPORT_DATA_START = `${GET_NOTIFICATION_REPORT_DATA}_START`;
export const GET_NOTIFICATION_REPORT_DATA_SUCCESS = `${GET_NOTIFICATION_REPORT_DATA}_SUCCESS`;
export const GET_NOTIFICATION_REPORT_DATA_FAIL = `${GET_NOTIFICATION_REPORT_DATA}_FAIL`;
export const NOTIFICATION_REPORT_HYDRATE_ACTIVE_DYNAMIC_FILTERS =
  'NOTIFICATION_REPORT_HYDRATE_ACTIVE_DYNAMIC_FILTERS';

export const hydrateActiveDynamicFilters = payload => {
  return {
    type: NOTIFICATION_REPORT_HYDRATE_ACTIVE_DYNAMIC_FILTERS,
    payload,
  };
};

export const getNotificationReportData = params => {
  const {
    from,
    to,
    deviceTypes,
    limit,
    offset,
    bqOffset,
    oltpOffset,
    sortBy,
    sortOrder,
    statuses,
    alertId,
    personUuids,
    planUuids,
    planName,
    formUuids,
    formName,
    includeSystemAlerts,
  } = params;

  return {
    type: GET_NOTIFICATION_REPORT_DATA,
    meta: {
      xmApi: true,
      method: 'get',
      uri: '/webapi/abe/1/notifications',
      params: {
        from,
        to,
        limit,
        offset,
        bqOffset,
        oltpOffset,
        includeSystemAlerts,
        ...(sortBy && { sortBy }),
        ...(sortOrder && { sortOrder }),
        ...(alertId && { alertId }),
        ...(deviceTypes && { deviceTypes }),
        ...(statuses && { statuses }),
        ...(personUuids && { personUuids }),
        ...(planUuids && { planUuids }),
        ...(planName && { planName }),
        ...(formUuids && { formUuids }),
        ...(formName && { formName }),
      },
    },
  };
};
